module.exports = __webpack_public_path__ + "img/logo-page.163f94b1.png";